<template>
<div class="page-header">
  <div class="page-title">
    {{title}}
  </div>
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true }
  },
  mounted () {
    const pageHeader = this.$el
    const clientRect = pageHeader.getBoundingClientRect()
    pageHeader.style.top = clientRect.top + 'px'
    pageHeader.style.left = clientRect.left + 'px'
    const container = pageHeader.closest('.el-container')
    container.style.setProperty('--page-header-top', clientRect.top + 'px')
    container.style.setProperty('--page-header-height', clientRect.height + 'px')
    container.classList.add('is-pageHeader')
  }
}
</script>

<style lang="scss" scoped>
.page-header {
  position: sticky;
  z-index: 200;
  margin: -20px -20px 0;
  padding: 20px;
  background-color: #F5F5F5;
  ::v-deep.page-title {
    display: inline-block;
    position: absolute;
    top: 20px;
    left: 20px;
    border-left: solid 1rem var(--primary-color);
    padding-left: 1rem;
    font-weight: bold;
    font-size: x-large;
    padding-top: 0.4rem;
  }
}
</style>
